/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCellphoneWireless: {
  name: 'cellphone-wireless';
  data: string;
} = {
  name: 'cellphone-wireless',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 2A1.5 1.5 0 0 1 4 .5h8A1.5 1.5 0 0 1 13.5 2v1a.5.5 0 0 1-1 0V2a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 1 1 0v1a1.5 1.5 0 0 1-1.5 1.5H4A1.5 1.5 0 0 1 2.5 14V2ZM11 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1-3.5a.5.5 0 0 0 0 1 2.5 2.5 0 0 1 0 5 .5.5 0 0 0 0 1 3.5 3.5 0 1 0 0-7Z" fill="currentColor"/></svg>`,
};
